
import Vue from 'vue'

/** Иконки из спрайта макета DH_OPZ_2_0_updated (symbol id="i-…"), контуры без изменений. */
const ICONS: Record<string, { viewBox: string; body: string }> = {
    grid: {
        viewBox: '0 0 24 24',
        body: '<path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z"/>',
    },
    calendar: {
        viewBox: '0 0 24 24',
        body:
            '<rect x="3" y="5" width="18" height="16" rx="3"/><path d="M7 3v4m10-4v4M3 11h18m-13 4h2m4 0h2"/>',
    },
    users: {
        viewBox: '0 0 24 24',
        body:
            '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/><circle cx="9" cy="7" r="4"/>',
    },
    down: {
        viewBox: '0 0 24 24',
        body: '<path d="m7 9 5 5 5-5"/>',
    },
    refresh: {
        viewBox: '0 0 24 24',
        body: '<path d="M20 7v5h-5M4 17v-5h5M19 11a7 7 0 0 0-12-5L4 9m1 4a7 7 0 0 0 12 5l3-3"/>',
    },
    info: {
        viewBox: '0 0 24 24',
        body: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10v.1"/>',
    },
    check: {
        viewBox: '0 0 24 24',
        body: '<path d="m5 12 4 4L19 6"/>',
    },
    swap: {
        viewBox: '0 0 24 24',
        body: '<path d="M4 7h16l-4-4m4 14H4l4 4M20 7l-4 4M4 17l4-4"/>',
    },
    cross: {
        viewBox: '0 0 24 24',
        body: '<path d="M4 6h5l10 12m-4 0h4v-4M4 18h5L19 6m-4 0h4v4"/>',
    },
    chart: {
        viewBox: '0 0 24 24',
        body: '<path d="M4 4v16h17M8 15v-4m5 4V7m5 8V5"/>',
    },
    settings: {
        viewBox: '0 0 24 24',
        body:
            '<path d="M4 6h16M4 12h16M4 18h16"/><rect x="8" y="4" width="4" height="4" rx="1" fill="currentColor"/><rect x="15" y="10" width="4" height="4" rx="1" fill="currentColor"/><rect x="6" y="16" width="4" height="4" rx="1" fill="currentColor"/>',
    },
    close: {
        viewBox: '0 0 24 24',
        body: '<path d="m6 6 12 12M6 18 18 6"/>',
    },
    external: {
        viewBox: '0 0 24 24',
        body: '<path d="M14 4h6v6M20 4l-9 9m-1-9H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5"/>',
    },
    left: {
        viewBox: '0 0 24 24',
        body: '<path d="m14 6-6 6 6 6"/>',
    },
    right: {
        viewBox: '0 0 24 24',
        body: '<path d="m10 6 6 6-6 6"/>',
    },
    sort: {
        viewBox: '0 0 12 16',
        body: '<path d="m3 5 3-3 3 3m-6 6 3 3 3-3"/>',
    },
    'sort-up': {
        viewBox: '0 0 12 16',
        body: '<path d="m3 9 3-3 3 3"/>',
    },
    'sort-down': {
        viewBox: '0 0 12 16',
        body: '<path d="m3 6 3 3 3-3"/>',
    },
    search: {
        viewBox: '0 0 24 24',
        body: '<circle cx="10" cy="10" r="6"/><path d="m15 15 5 5"/>',
    },
    plus: {
        viewBox: '0 0 24 24',
        body: '<path d="M12 5v14M5 12h14"/>',
    },
    trash: {
        viewBox: '0 0 24 24',
        body: '<path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5m4-5v5"/>',
    },
    alert: {
        viewBox: '0 0 24 24',
        body: '<path d="m12 3 10 18H2zM12 9v5m0 3v.1"/>',
    },
}

export default Vue.extend({
    name: 'Opz2Icon',
    props: {
        name: { type: String, required: true },
        cls: { type: String, default: '' },
    },
    computed: {
        icon(): { viewBox: string; body: string } {
            return ICONS[this.name] ?? { viewBox: '0 0 24 24', body: '' }
        },
    },
})
